import React from 'react';
import { FiSearch, FiX } from 'react-icons/fi';

export default function SearchField({ label, value, onChange, placeholder = label }) {
    return <div className="access-search">
        <FiSearch aria-hidden="true" />
        <input type="search" aria-label={label} placeholder={placeholder} value={value} onChange={(event) => onChange(event.target.value)} />
        {value && <button type="button" aria-label={`Clear ${label.toLowerCase()}`} onClick={() => onChange('')}><FiX aria-hidden="true" /></button>}
    </div>;
}
